<script setup>
  import {
    nextTick,
    onMounted,
    ref,
    watch
  } from 'vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { usePropertySearch } from '@composables/usePropertySearch.js'

  const list = ref([])

  const SELECTOR = '#fixed_contact_links'

  const { isEn, t, vt } = useI18n('properties.city.js')
  const { callGet } = useAjax()

  const {
    cities,
    location,
    optionsPrefectures,
    type,
    propertiesBaseUrl,
    propertiesUrl,
  } = usePropertySearch({
    afterGetPrefectures: () => initializeSelect()
  })

  location.value = window.app.page.location
  type.value = window.app.page.type

  onMounted(() => {
    initializeSelect()
    getCities()
  })

  // 多分SumoSelectを使用しているせいでinputイベントが取れない
  watch(location, () => getCities())
  watch(type, () => getCities())

  /**
   * 一覧の取得
   */
  const getCities = async () => {
    const url = new URL([window.app.page.root_path, type.value, location.value].join('/'))
    history.pushState(null, '', url.toString())
    url.pathname = `${url.pathname.replace(/\/$/, '')}.json`
    url.searchParams.append('u', window.app.common.cacheKey[type.value])
    const response = await callGet(url.toString())

    list.value = response.wards ? response.wards : []
    cities.value = []
  }

  /**
   * 入力操作
   */
  const handleInput = () => {
    const count = cities.value.length
    setTimeout(() => {
      if (count == 0 && cities.value.length > 0) {
        $(SELECTOR).fadeIn()
      }
      else if (count > 0 && cities.value.length == 0) {
        $(SELECTOR).fadeOut()
      }
    }, 100)
  }

  /**
   * 行政区の全選択／解除
   */
  const handleInputWard = (e, ward) => {
    handleInput()
    if (e.target.checked) {
      const current = new Set(cities.value)
      ward.cities.filter((city) => !current.has(city.id) && city.properties_count > 0).forEach((city) => cities.value.push(city.id))
    }
    else {
      const set = new Set(ward.cities.map((city) => city.id))
      cities.value = cities.value.filter((id) => !set.has(id))
    }
  }

  /**
   * 選択肢の初期化
   */
  const initializeSelect = () => {
    if (optionsPrefectures.value.length > 0) {
      nextTick(() => $("#main .sumo_select select").SumoSelect())
    }
  }

  /**
   * 検索実行
   */
  const submit = () => {
    window.location.href = propertiesUrl()
  }
</script>

<template>
  <div id="body">
    <div id="main">
      <div class="head">
        <h1 class="c-ttl">{{ vt('title') }}</h1>
      </div>
      <div v-show="optionsPrefectures.length > 0" class="sumo_select" id="search_op">
        <div class="container">
          <div class="toggle_contents_header">Search for Properties</div>
          <div class="c-sumoselect selects selects_pc sumo_select toggle_contents toggle_contents_flex">
            <div class="inner">
              <div class="select_box">
                <label class="select_type_a properties-type">
                  <select v-model="type" class="search-properties-type" tabindex="-1">
                    <option value="sale">{{ t(isEn ? 'c.for_sale.other' : 'c.for_sale') }}</option>
                    <option value="rent">{{ t(isEn ? 'c.for_rent.other' : 'c.for_rent') }}</option>
                  </select>
                </label>

                <label class="select_type_a location">
                  <p>{{ vt('select_prefecture') }}</p>
                  <select v-model="location" class="search-property-type-detail select_pc" placeholder="Prefecture" tabindex="-1" name="location">
                    <option></option>
                    <option v-for="option in optionsPrefectures" :key="`prefecture-${option.value}`" :value="option.en">{{ option.label }}</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-wrap">
        <div class="p-search__block">
          <h2 class="sec-title">{{ vt('please_select_cities') }}</h2>
          <div class="frame">
            <template v-for="(ward, index) in list" :key="`ward-${ward.url}`">
              <div v-if="list.length > 1" class="p-search-ttl">
                <input :id="`ward-${index}`" type="checkbox" @input="(e) => handleInputWard(e, ward)">
                <label class="checkbox" :for="`ward-${index}`">
                  <template v-if="ward.url && ward.properties_count > 0">
                    <a :href="`${propertiesBaseUrl}/${ward.url}`">{{ ward.name }}({{ ward.properties_count }})</a>
                  </template>
                  <template v-else>
                    <span>{{ ward.name }}({{ ward.properties_count }})</span>
                  </template>
                </label>
              </div>
              <ul class="selector">
                <li v-for="city in ward.cities" :key="`city-${city.id}`">
                  <input v-model="cities" :id="`city-${city.id}`" :disabled="city.properties_count == 0" type="checkbox" :value="city.id" @input="handleInput">
                  <label class="checkbox" :for="`city-${city.id}`">
                    <template v-if="city.properties_count > 0">
                      <a :href="`${propertiesBaseUrl}/${city.url}`">
                        {{ city.name }}({{ city.properties_count }})
                      </a>
                    </template>
                    <template v-else>
                      <span>{{ city.name }}({{ city.properties_count }})</span>
                    </template>
                  </label>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content_small" id="fixed_contact_links">
    <a class="btn" @click="submit">{{ t('c.search') }}</a>
  </div>
</template>
